import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import localeText from "../../../../../locale";
import { formatPrice } from "../../../../../utilities/formatPrice";

const ExtracreditTransferStep2Values = ({
  recipient,
  balance,
  usableBalance,
  currencySymbol,
  amount,
  setAmount,
  fee,
  loadingIntent,
  onAmountBlur,
  onBack,
  onNext,
  canProceed,
}) => {
  return (
    <div className="flex flex-column align-items-center gap-4">
      <div
        className="p-3"
        style={{
          background:
            "linear-gradient(to bottom,rgba(113, 119, 132, 0.25),rgba(113, 119, 132, 0.03))",
          borderRadius: "50%",
        }}
      >
        <div
          className="flex align-items-center justify-content-center overflow-hidden"
          style={{ width: "96px", height: "96px", backgroundColor: "#FFFFFF", borderRadius: "50%" }}
        >
          <i className="pi pi-dollar text-5xl" style={{ color: "var(--theme-text-muted, #5C5C5C)" }} />
        </div>
      </div>
      <div className="text-center w-full">
        <h4 className="mb-2 m-0">{localeText("values") || "Valores"}</h4>
        <p className="text-600 mb-4 m-0">
          {(
            localeText("valuesHint") || "Insira quanto você deseja transferir para {name}."
          ).replace("{name}", recipient?.name || recipient?.firstName || recipient?.username || "")}
        </p>
      </div>
      <div
        className="w-full p-4 border-round-md mb-2"
        style={{ border: "1px solid var(--theme-border, #E9ECEF)", maxWidth: "400px" }}
      >
        <div className="text-sm text-600 mb-2">{localeText("recipientDetails")}</div>
        <div className="flex align-items-center justify-content-between">
          <div>
            <div className="font-semibold" style={{ color: "var(--theme-text, #171717)" }}>
              {recipient?.name || recipient?.firstName || recipient?.username}
            </div>
            <div className="text-sm text-600">{recipient?.email}</div>
          </div>
          {recipient?.username && <div className="text-sm text-500">{recipient.username}</div>}
        </div>
      </div>
      <div
        className="w-full p-4 border-round-md"
        style={{ border: "1px solid var(--theme-border, #E9ECEF)", maxWidth: "400px" }}
      >
        <div className="mb-2">
          <span className="text-600">{localeText("available")}: </span>
          <span className="font-semibold">{formatPrice(usableBalance ?? balance ?? 0)} ECR</span>
        </div>
        <div className="mb-4">
          <label htmlFor="amount-input" className="block mb-2 font-medium">
            {localeText("enterAmount")}
          </label>
          <InputNumber
            id="amount-input"
            value={amount}
            onValueChange={(e) => setAmount(e.value ?? 0)}
            onBlur={onAmountBlur}
            mode="decimal"
            minFractionDigits={2}
            maxFractionDigits={2}
            min={0}
            max={Number(usableBalance ?? balance ?? 0)}
            suffix=" ECR"
            className="w-full"
            placeholder="0.00"
          />
        </div>
        {fee != null && fee > 0 && (
          <p className="text-600 text-sm mb-4">
            {localeText("platformFee")}: {currencySymbol} {formatPrice(fee)}
          </p>
        )}
        {loadingIntent && (
          <p className="text-sm text-500 mb-4">{localeText("loading") || "Carregando..."}</p>
        )}
        <hr className="my-4" style={{ borderColor: "var(--theme-border, #E9ECEF)" }} />
        <div className="flex gap-2">
          <Button
            size="small"
            label={localeText("backAction")}
            className="p-button-outlined border-round-md p-no-outline flex-1"
            style={{ border: "1px solid var(--theme-border, #EBEBEB)", color: "var(--theme-text-muted, #5C5C5C)" }}
            onClick={onBack}
          />
          <Button
            size="small"
            label={localeText("nextAction")}
            className="border-round-md p-no-outline border-none flex-1"
            style={{ backgroundColor: "var(--theme-primary, #1DAF61)", color: "#FFFFFF" }}
            onClick={onNext}
            disabled={!canProceed}
          />
        </div>
      </div>
    </div>
  );
};

export default ExtracreditTransferStep2Values;
